var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"white--text",attrs:{"color":"primary","app":""}},[_c('v-spacer'),_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" - "),_c('strong',[_vm._v("Barter For Things")])]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }